import React, {Component} from 'react';
import TablePagination from '@material-ui/core/TablePagination';
import ListHoc from "../../../../../HocHelpers/ListHoc";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import withStyles from "@material-ui/core/styles/withStyles";
import './TableFooterList.css'

const styles = () => ({
    tableFooterWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        minHeight: 40,
        height: 40,
    },
    toolBarPagination: {
        height: 30,
        minHeight: 30
    },
    paginationAction: {
        flexShrink: 0,
        display: 'flex'
    },
    buttonChangePage: {
        padding: 0
    },
    currentPage: {
        paddingTop: 3,
        fontSize: '0.75rem'
    },
    rowsPerPageRoot: {
        margin: '0px 6px 0 4px'
    },
    select: {
        paddingLeft: 0,
        fontSize: '0.75rem'
    },
    countingWrapper: {
        flexGrow: 1,
        display: 'flex',
        paddingLeft: 9
    },
    menuItem: {
        padding: '3px 5px'
    },
    caption: {
        fontSize: '0.75rem'
    }
});

class TableFooterList extends Component {
    TablePaginationActions = () => {
        const {classes} = this.props;
        return (
            <div className={classes.paginationAction}>
                <IconButton
                    className={classes.buttonChangePage}
                    disabled
                    aria-label="first page"
                >
                    <FirstPageIcon/>
                </IconButton>
                <IconButton
                    className={classes.buttonChangePage}
                    disabled
                    aria-label="previous page">
                    <KeyboardArrowLeft/>
                </IconButton>
                1
                <IconButton
                    className={classes.buttonChangePage}
                    disabled
                    aria-label="next page"
                >
                    <KeyboardArrowRight/>
                </IconButton>
                <IconButton
                    className={classes.buttonChangePage}
                    disabled
                    aria-label="last page"
                >
                    <LastPageIcon/>
                </IconButton>
            </div>
        );
    };


    render() {
        const {
            classes,
            data,
            changeRowsPerPage,
            page,
            rowsPerPage,
            rowsPerPageOptions,
            sumSelectedFields,
            showCountSelected
        } = this.props;

        return (
            <div className={classes.tableFooterWrapper}>
                <div className={classes.countingWrapper}>
                    {showCountSelected && (
                        <span>Count: 0</span>
                    )}
                    {sumSelectedFields && (
                        <span style={{marginLeft: 15}}>Total: 0</span>
                    )}
                </div>
                <TablePagination count={data.totalElements}
                                 onChangePage={() => {
                                 }}
                                 component={"div"}
                                 onChangeRowsPerPage={changeRowsPerPage}
                                 rowsPerPageOptions={rowsPerPageOptions}
                                 page={page}
                                 rowsPerPage={rowsPerPage}
                                 backIconButtonProps={{
                                     'aria-label': 'previous page',
                                 }}
                                 classes={{
                                     toolbar: classes.toolBarPagination,
                                     caption: classes.caption,
                                     selectRoot: classes.rowsPerPageRoot,
                                     select: classes.select,
                                     menuItem: classes.menuItem
                                 }}
                                 SelectProps={{
                                     disabled: true,
                                     inputProps: {'aria-label': 'Rows Per Page'},
                                     native: false,
                                 }}
                                 labelRowsPerPage={'Size'}
                                 ActionsComponent={this.TablePaginationActions}
                                 nextIconButtonProps={{
                                     'aria-label': 'next page',
                                 }}/>
            </div>
        );
    }
}

export default ListHoc(withStyles(styles)(TableFooterList));